import React from 'react';
import PropTypes from 'prop-types';
import renderRoutes from 'react-router-config/renderRoutes';
import { ConnectedRouter } from 'react-router-redux';
import { Provider } from 'react-redux';
import get from 'lodash/get';
import getRoutesWithStore from '../../react_router/react_router';
import Head from '../components/head/head';
import AmpHead from '../components/head/amp_head';
import FbiaHead from '../components/head/fbia_head';
import { TrackerProvider } from '../../utils/tracking/components';
import configuredTracker from '../../utils/tracking/configureTracker';
import MindEdge from './pages/mindedge/mindedge';
import { UserProvider } from '../components/context/userContext';

function Root({ store, history, getRoutes, requestUrl }) {
  const state = store.getState();
  const amp = get(state, 'config.amp');
  const fbia = get(state, 'config.fbia');

  if (amp) {
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <html amp="" lang="en-US" className="fonts-loaded">
            <AmpHead />
            {renderRoutes(getRoutes(store))}
          </html>
        </ConnectedRouter>
      </Provider>
    );
  } else if (fbia) {
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <html lang="en-US" prefix="op: http://media.facebook.com/op#">
            <FbiaHead />
            {renderRoutes(getRoutes(store))}
          </html>
        </ConnectedRouter>
      </Provider>
    );
  } else if (requestUrl.includes('/courses')) {
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <TrackerProvider tracker={configuredTracker}>
            <html lang="en-US" id="mindedge">
              <Head title="Exclusive Online Courses Powered By MindEdge | Fast Company" />
              <MindEdge />
            </html>
          </TrackerProvider>
        </ConnectedRouter>
      </Provider>
    );
  }

  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <TrackerProvider tracker={configuredTracker}>
          <html lang="en-US">
            <UserProvider>
              <Head />
              {renderRoutes(getRoutesWithStore(store))}
            </UserProvider>
          </html>
        </TrackerProvider>
      </ConnectedRouter>
    </Provider>
  );
}

Root.defaultProps = {
  getRoutes: undefined,
  requestUrl: ''
};

Root.propTypes = {
  store: PropTypes.shape({}).isRequired,
  history: PropTypes.shape({}).isRequired,
  getRoutes: PropTypes.func,
  requestUrl: PropTypes.string
};

export default Root;
